import { ReadStoreDto, ReadDefaultStoreDto, StoreTypeEnum } from '@goparrot/store-v2-sdk';

export const isDefaultStore = (data?: ReadStoreDto | ReadDefaultStoreDto): data is ReadDefaultStoreDto => StoreTypeEnum.DEFAULT === data?.type;
